module.exports = __webpack_public_path__ + "static/media/shape_N.c4c7eea2.glb";